export default __webpack_public_path__ + "locales/nl/ConvertDialog.json?hash=fbf406e97ec0f0bff853e10dcfa3232c";